import React from 'react';

import {useGrid} from './GridContext';
import GridReviewPanel from './GridReviewPanel';
import GridSizePicker from './GridSizePicker';
import {MapInteractionTool} from '../view';

interface Props {
  isSidebarExpanded: boolean;
  activeMapInteractionTool: MapInteractionTool | null;
}

/**
 * Single visibility decision for the grid review overlays: nothing when the
 * tool is closed, the size picker while the user is choosing, the review
 * panel after they commit. Centralizing the choice here keeps the rule in
 * one place — the children just render unconditionally.
 */
const GridReviewTools: React.FunctionComponent<Props> = ({
  isSidebarExpanded,
  activeMapInteractionTool,
}) => {
  const {isEnabled, isPickingGridSize} = useGrid();
  if (!isEnabled) return null;
  return isPickingGridSize ? (
    <GridSizePicker
      isSidebarExpanded={isSidebarExpanded}
      activeMapInteractionTool={activeMapInteractionTool}
    />
  ) : (
    <GridReviewPanel
      isSidebarExpanded={isSidebarExpanded}
      activeMapInteractionTool={activeMapInteractionTool}
    />
  );
};

export default GridReviewTools;
